"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COUPON_TYPE = exports.COUPON_DISCOUNT_TYPE = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var constants_1 = require("../../constants");

var ErrorMessage_1 = tslib_1.__importDefault(require("../ErrorMessage"));

var styles = tslib_1.__importStar(require("./CouponApplyList.style"));

var CouponApplyListItem_1 = tslib_1.__importDefault(require("./CouponApplyListItem"));

var COUPON_DISCOUNT_TYPE;

(function (COUPON_DISCOUNT_TYPE) {
  COUPON_DISCOUNT_TYPE["FLAT"] = "FLAT";
  COUPON_DISCOUNT_TYPE["RATE"] = "RATE";
})(COUPON_DISCOUNT_TYPE = exports.COUPON_DISCOUNT_TYPE || (exports.COUPON_DISCOUNT_TYPE = {}));

var COUPON_TYPE;

(function (COUPON_TYPE) {
  COUPON_TYPE["DIRECT_COUPON"] = "DIRECT_COUPON";
  COUPON_TYPE["REDEEM_CODE_COUPON"] = "REDEEM_CODE_COUPON";
  COUPON_TYPE["PROMOTION_CODE_COUPON"] = "PROMOTION_CODE_COUPON";
})(COUPON_TYPE = exports.COUPON_TYPE || (exports.COUPON_TYPE = {}));

function CouponApplyList(_ref) {
  var className = _ref.className,
      coupons = _ref.coupons,
      onApply = _ref.onApply,
      selectedCouponId = _ref.selectedCouponId;

  function handleApply(coupon) {
    return function () {
      onApply(coupon);
    };
  }

  return coupons.length !== 0 ? jsx_runtime_1.jsx("div", Object.assign({
    role: "list",
    className: className
  }, {
    children: coupons.map(function (coupon) {
      return jsx_runtime_1.jsx(CouponApplyListItem_1.default, {
        flatAmount: coupon.flatAmount,
        discountRate: coupon.discountRate,
        name: coupon.couponName,
        conditions: coupon.condition,
        description: coupon.description,
        expireDate: coupon.expireDate,
        discountType: coupon.discountType,
        isUsable: coupon.isUsable,
        isPublished: coupon.isRecentPublished,
        isSelected: selectedCouponId === coupon.id,
        onApply: handleApply({
          id: coupon.id,
          discountType: coupon.discountType,
          discountRate: coupon.discountRate,
          maxDiscountAmount: coupon.maxDiscountAmount,
          flatAmount: coupon.flatAmount,
          couponName: coupon.couponName
        })
      }, coupon.id);
    })
  }), void 0) : jsx_runtime_1.jsx(ErrorMessage_1.default, {
    css: styles.emptyCouponList,
    title: "\uBCF4\uC720\uD55C \uCFE0\uD3F0\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    content: "\uD560\uC778 \uCFE0\uD3F0\uC744 \uCC3E\uC544\uBCF4\uC138\uC694!",
    illust: "".concat(constants_1.S3_RESOURCE_ICONS, "/ic_emptycoupon_64x64_gray_300.svg")
  }, void 0);
}

exports.default = CouponApplyList;